<template>
    <div style="padding-bottom: 80px;">
      <van-nav-bar
        title="高级机械维修工程"
        left-arrow
        fixed
        placeholder
        @click-left="onClickLeft"
        @click-right="onClickRight">
        <template #right>
          <van-icon name="gengduo1" size="28" />
        </template>
      </van-nav-bar>
      <div class="detail-cont">
        <div class="job-header">
          <h2>高级机械维修工程师</h2>
          <div class="wages">8000-10000 元/月</div>
          <ul class="condition">
            <li>
              <van-icon name="renyuan"></van-icon>
              <span>招若干人</span>
            </li>
            <li>
              <van-icon name="shijian"></van-icon>
              <span>3-4年</span>
            </li>
            <li>
              <van-icon name="xueli"></van-icon>
              <span>本科</span>
            </li>
          </ul>
          <div class="title-02">
            <h3>职位福利</h3>
              <span class="icon-more" @click="showMore" v-if="welfarelist.length > 5" :class="{'active':active}" >{{brandFold?'查看全部':'收起'}}</span>
          </div>
          <ul class="welfare">
            <li v-for="item in showMoreList" :key="item.index">{{item.welfare}}</li>
          </ul>
        </div>
        <ul class="edit-icon">
          <li>
            <van-icon name="fenxiang"></van-icon>
            <span>分享</span>
          </li>
          <li>
            <van-icon name="jubao"></van-icon>
            <span>举报</span>
          </li>
        </ul>
        <div class="contact">
          <div class="person">
            <img src="../../../assets/img/user.png">
            <h3>凌思
              <small>千岸科技·人事主管</small>
            </h3>
          </div>
          <van-icon name="gengduo"></van-icon>
        </div>
        <div class="title-01">
          <h2>职位描述</h2>
        </div>
        <ol class="detail-desc">
          <li>1. 负责车辆本身日常维护； </li>
          <li>2. 负责无人驾驶车载设备的结构安装、调试、日常维护； </li>
          <li>3.辅助机械结构设计师完成结构设计及线束布置； </li>
          <li>4.提供工艺分析，DFM。能在安装，保养，调试时提出风险点包括针对操作，零部件或者车辆本身。 </li>
          <li>5.熟悉整车结构(电器、底盘、线束等)，能够对整车进行熟练拆装，熟悉内外饰的拆装操作； </li>
          <li>6.掌握常用钳工技能(锉、锯、打孔、攻丝、钣金等)； </li>
          <li>7.具备C1或以上驾驶证资格，开车熟练； </li>
          <li>8.具备国家汽车修理工高级认证； </li>
          <li>9.有新能源车高压操作的认证的或者是新能源车高压维修经验的优先考虑； </li>
          <li>10.有汽车行业相关行业经验者优先，如4S店维修，OEM样品车间经验； </li>
          <li> 11.有自动驾驶相关行业经验者优先。 </li>
        </ol>
        <div class="line"></div>
        <div class="company">
          <div class="company-info">
            <img src="../../../assets/img/logo1.jpg">
            <div class="header-top">
              <h3>上海千岸电器股份有限公司</h3>
              <ul>
                <li v-for="item in featurelist" :key="item.index">
                  {{item.detail}}
                </li>
              </ul>
            </div>
          </div>
          <van-icon name="gengduo"></van-icon>
        </div>
        <div class="map">
          <div class="location">
            <h3>工作地址</h3>
            <p>上海市嘉定区上海捷新动力电池系统有限公司 585号</p>
          </div>
          <img src="../../../assets/img/map.jpg"/>
        </div>
      </div>
      <div class="fixed-bottom">
        <div class="collection">
          <van-icon name="collection" :class="{'active':active}" @click="toggleClass"></van-icon>
          <span>收藏职位</span>
        </div>
        <van-button type="primary" class="btn-gray" color="#EEEFF1" round>该 职 位 已 关 闭</van-button>
        <!--<van-button type="primary" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>投 递 简 历</van-button>-->
      </div>
      <van-share-sheet
        v-model="showShare"
        title="我要分享"
        :options="options"
        @select="onReport"
      />
      <!--弹出举报-->
      <transition name="fade">
        <div class="filter-cont report" v-show="reportPop">
          <div class="pop-header">
            <van-icon name="closed" @click="hiddenReportPop"></van-icon>
            <h2>举报</h2>
          </div>
          <h3>举报理由 </h3>
          <ul class="filter-list">
            <li v-for="(item,index) in reason" :key="item.index" :class="{checked:index==r}" @click="selectReason(index)"><span>{{item}}</span></li>
          </ul>
          <h3>举报说明 </h3>
          <textarea class="textarea" placeholder="请输入您的反馈，我们将不断为您改进，一经核实
将尽快联系您～" name="" id="" cols="30" rows="10">

        </textarea>
          <van-uploader v-model="fileList" multiple />
          <div class="fixed-bottom">
            <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>提 交</van-button>
          </div>
        </div>
      </transition>
      <van-popup v-model="popup" closeable>
        <div class="pop-cont">
          <img src="../../../assets/img/popbg.png"/>
          <p>你离心仪的职位只差一份简历</p>
          <van-button type="primary" color="linear-gradient(to right top, #F69B58,#F87342)" round>创建简历</van-button>
        </div>
      </van-popup>
    </div>
</template>

<script>
export default {
  name: 'jobDetail',
  data() {
    return {
      brandFold: true,
      active: true,
      more: '',
      popup:true,
      r: 0,
      reportPop: false,
      showShare: false,
      fileList: [
        { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
        // Uploader 根据文件后缀来判断是否为图片文件
        // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
        { url: 'https://cloud-image', isImage: true }
      ],
      selectReason(index) {
        this.r = index
      },
      options: [
        [
          { name: '微信', icon: require('../../../assets/img/share/wechat.png') },
          { name: '朋友圈', icon: require('../../../assets/img/share/pyq.png') },
          { name: 'QQ', icon: require('../../../assets/img/share/qq.png') },
          { name: '微博', icon: require('../../../assets/img/share/weibo.png') }
        ],
        [
          { name: '我要举报', icon: require('../../../assets/img/share/jubao.png') }
        ]
      ],
      featurelist: [
        {
          detail: '上海航天电子有限公司'
        }, {
          detail: '1000人以上'
        }, {
          detail: '移动互联网'
        }
      ],
      reason: ['广告', '政治敏感内容', '资质造假', '人身攻击', '传 销', '以培训名义招生', '职位地址虚假', '其他', '索取隐私'],

      welfarelist: [
        {
          welfare: '五险一金'
        }, {
          welfare: '包吃'
        }, {
          welfare: '包住'
        }, {
          welfare: '每周双休'
        },
        {
          welfare: '五险一金'
        }, {
          welfare: '包吃'
        }, {
          welfare: '包住'
        }, {
          welfare: '每周双休'
        }
      ]
    }
  },
  computed: {
    showMoreList: {
      get: function () {
        if (this.brandFold) {
          if (this.welfarelist.length < 5) {
            return this.welfarelist
          }
          let newList = []
          for (var i = 0; i < 5; i++) {
            let item = this.welfarelist[i]
            newList.push(item)
          }
          return newList
        }
        return this.welfarelist
      },
      set: function (val) {
        this.showMoreList = val
      }
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickRight() {
      this.showShare = true
    },
    toggleClass() {
      this.active = !this.active
    },
    showMore() {
      this.brandFold = !this.brandFold
      this.active = !this.active
    },
    hiddenReportPop() {
      this.reportPop = false
    },
    onReport() {
      this.reportPop = true
      this.showShare = false
    }
  }

}
</script>

<style lang="less" scoped>
  /deep/.van-nav-bar{
    background: #1C54CF;
    .van-nav-bar__title,i{
      color:#fff;
      font-weight: normal;
    }
  }
  /deep/.van-share-sheet__title{
    font-size: 14px;
    color:#ADB0B6;
  }
  /deep/.van-share-sheet__options{
    .van-share-sheet__option{
      width: 25%;
    }
    .van-share-sheet__icon{
      width: auto;
      height: 30px;
    }
  }
  /deep/.van-uploader{
    margin:10px 16px;
    .van-uploader__preview-delete-icon{
      top: -3px;
    }
  }
  .textarea{
    width:100%;
    min-height: 170px;
    background: #F8F9FB;
    border-radius: 4px;
    border: none;
    margin:2px 16px;
    padding:16px;
    font-size: 14px;
    &::-webkit-input-placeholder{
      color:#ccc
    }
  }
  .fixed-bottom{
    padding:10px 16px 20px;
    button{
      flex:1;
    }
  }
  .edit-icon{
    border-bottom: 1px solid #eee;
    margin:0 16px;
    padding-bottom: 16px;
  }
</style>
